var map = {
	"./01_rooms-shared-room.1024.jpg": 1372,
	"./01_rooms-shared-room.1024.webp": 266,
	"./01_rooms-shared-room.1280.jpg": 9416,
	"./01_rooms-shared-room.1280.webp": 9386,
	"./01_rooms-shared-room.1536.jpg": 6304,
	"./01_rooms-shared-room.1536.webp": 1058,
	"./01_rooms-shared-room.640.jpg": 151,
	"./01_rooms-shared-room.640.webp": 7221,
	"./01_rooms-shared-room.768.jpg": 8288,
	"./01_rooms-shared-room.768.webp": 6764,
	"./01_rooms-shared-room.original.jpg": 9264,
	"./01_rooms-shared-room.original.webp": 3626,
	"./01_rooms-shared-room.thumbnail.jpg": 4569,
	"./01_rooms-shared-room.thumbnail.webp": 4819,
	"./02_rooms-shared-bed1.1024.jpg": 6064,
	"./02_rooms-shared-bed1.1024.webp": 6882,
	"./02_rooms-shared-bed1.1280.jpg": 7508,
	"./02_rooms-shared-bed1.1280.webp": 5266,
	"./02_rooms-shared-bed1.1536.jpg": 5980,
	"./02_rooms-shared-bed1.1536.webp": 2666,
	"./02_rooms-shared-bed1.640.jpg": 1403,
	"./02_rooms-shared-bed1.640.webp": 5469,
	"./02_rooms-shared-bed1.768.jpg": 740,
	"./02_rooms-shared-bed1.768.webp": 6180,
	"./02_rooms-shared-bed1.original.jpg": 940,
	"./02_rooms-shared-bed1.original.webp": 6370,
	"./02_rooms-shared-bed1.thumbnail.jpg": 997,
	"./02_rooms-shared-bed1.thumbnail.webp": 9659,
	"./03_rooms-shared-bed2.1024.jpg": 7410,
	"./03_rooms-shared-bed2.1024.webp": 4012,
	"./03_rooms-shared-bed2.1280.jpg": 6918,
	"./03_rooms-shared-bed2.1280.webp": 2252,
	"./03_rooms-shared-bed2.1536.jpg": 1610,
	"./03_rooms-shared-bed2.1536.webp": 9576,
	"./03_rooms-shared-bed2.640.jpg": 1353,
	"./03_rooms-shared-bed2.640.webp": 5947,
	"./03_rooms-shared-bed2.768.jpg": 7726,
	"./03_rooms-shared-bed2.768.webp": 5550,
	"./03_rooms-shared-bed2.original.jpg": 3162,
	"./03_rooms-shared-bed2.original.webp": 3320,
	"./03_rooms-shared-bed2.thumbnail.jpg": 5623,
	"./03_rooms-shared-bed2.thumbnail.webp": 7245,
	"./04_rooms-shared-bed-&-lockers.1024.jpg": 4660,
	"./04_rooms-shared-bed-&-lockers.1024.webp": 8260,
	"./04_rooms-shared-bed-&-lockers.1280.jpg": 8416,
	"./04_rooms-shared-bed-&-lockers.1280.webp": 308,
	"./04_rooms-shared-bed-&-lockers.1536.jpg": 8920,
	"./04_rooms-shared-bed-&-lockers.1536.webp": 2848,
	"./04_rooms-shared-bed-&-lockers.640.jpg": 9391,
	"./04_rooms-shared-bed-&-lockers.640.webp": 4051,
	"./04_rooms-shared-bed-&-lockers.768.jpg": 3256,
	"./04_rooms-shared-bed-&-lockers.768.webp": 438,
	"./04_rooms-shared-bed-&-lockers.original.jpg": 9256,
	"./04_rooms-shared-bed-&-lockers.original.webp": 7776,
	"./04_rooms-shared-bed-&-lockers.thumbnail.jpg": 5361,
	"./04_rooms-shared-bed-&-lockers.thumbnail.webp": 8373,
	"./05_rooms-shared-room-full.mp4": 8440
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8348;